<ng-container *ngIf="(_profile$ | async).attributes.real_conversions_correction_mode !== undefined">
  <button class="display-flex flex-align-center" mat-menu-item [matMenuTriggerFor]="reportRealConversionsMenu">
    <mat-icon class="material-icons-outlined">settings_suggest</mat-icon>
    <span>{{ 'button.wall_garden_option' | translate }}</span>
  </button>

  <mat-menu #reportRealConversionsMenu="matMenu" class="nice-menu">
    <div style="padding: 16px;">
      {{ 'real_conversions.correction_status' | translate }} <span
      class="color-{{modeTo('color', (_profile$ | async).attributes.real_conversions_correction_mode)}}">{{ modeTo('label', (_profile$ | async).attributes.real_conversions_correction_mode) | translate }}</span>
    </div>
    <button buttonType="mat-button" class="display-flex flex-align-center" mat-menu-item
            (click)="setRealConversions(0)">
      <mat-icon>do_disturb_on</mat-icon>
      <span>{{ 'real_conversions.disable_correction' | translate }}</span>
    </button>
    <button buttonType="mat-button" class="display-flex flex-align-center" mat-menu-item
            (click)="setRealConversions(1)">
      <mat-icon>ads_click</mat-icon>
      <span>{{ 'real_conversions.post_click_correction' | translate }}</span>
    </button>
    <button buttonType="mat-button" class="display-flex flex-align-center" mat-menu-item
            (click)="setRealConversions(2)">
      <mat-icon>visibility</mat-icon>
      <span>{{ 'real_conversions.post_view_correction' | translate }}</span>
    </button>
    <button buttonType="mat-button" class="display-flex flex-align-center" mat-menu-item
            (click)="setRealConversions(3)">
      <mat-icon>toggle_on</mat-icon>
      <span>{{ 'real_conversions.post_click_view_correction' | translate }}</span>
    </button>
  </mat-menu>
</ng-container>
